import React from "react";
import { makeStyles } from "@material-ui/core";

import { SignupMenu } from "../components/signup-menu/SignupMenu";

export interface SignupLayoutProps {
  children: React.ReactNode;
  withMenu?: boolean;
  mode?: "dark" | "light";
}

export const useStyles = makeStyles(
  (theme) => ({
    root: (props: SignupLayoutProps) => ({
      width: "100%",
      overflow: "hidden",

      "& .topNavWrapper": {
        width: "100%",
        transition: "width .5s ease-out",
        paddingLeft: theme.spacing(5),
        backgroundColor: theme.palette.common.white,
        boxShadow: theme.shadows[1],

        [theme.breakpoints.down("xs")]: {
          paddingLeft: theme.spacing(1),
        },

        position: "fixed",
      },
    }),

    wrapper: {
      width: "100%",
      overflow: "auto",

      marginTop: (props: SignupLayoutProps) => (props.withMenu ? 58 : 0),
      height: (props: SignupLayoutProps) =>
        props.withMenu ? "calc(100vh - 58px)" : "100vh",
      background: (props: SignupLayoutProps) =>
        props.mode === "dark" ? "#f4f6f8" : theme.palette.common.white,

      paddingBottom: theme.spacing(8),
      paddingTop: theme.spacing(1),
    },

    content: {
      transition: "width .5s ease-out",
    },
  }),
  { name: "signup-layout-style", flip: null }
);

export const SignupLayout = (props: SignupLayoutProps) => {
  const classes = useStyles(props);
  // Props
  const { withMenu } = props;

  return (
    <div className={classes.root}>
      {withMenu ? (
        <div className="topNavWrapper">
          <SignupMenu />
        </div>
      ) : (
        <></>
      )}

      <div className={classes.wrapper}>
        <div className={classes.content}>{props.children}</div>
      </div>
    </div>
  );
};

SignupLayout.defaultProps = {
  mode: "light",
  withMenu: false,
};
